import { buildAmountSummary } from './helper';
import { useSalesOrderForFulfillmentId, useFulfillmentPlanForFulfillmentId } from '../../hooks/entities/selectors/fulfillments';

export const useGetFulfillmentPlanAmountSummaryFromFulfillment = (fulfillmentId) => {
  const fulfillmentPlan = useFulfillmentPlanForFulfillmentId(fulfillmentId);
  const amountSummary = fulfillmentPlan.amountSummary;

  return buildAmountSummary(amountSummary?.shipping, amountSummary?.tax, amountSummary?.totalPaid, amountSummary?.total);
};

export const useGetSalesOrderAmountSummaryFromFulfillment = (fulfillmentId) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const salesOrderAmountSummary = salesOrder.amountSummary;
  if (!salesOrderAmountSummary) {
    return undefined;
  }

  return buildAmountSummary(
    salesOrderAmountSummary?.shippingPaid,
    salesOrderAmountSummary?.taxPaid,
    salesOrderAmountSummary?.totalPaid,
    salesOrderAmountSummary?.orderTotal,
  );
};

export const useGetAmountSummaryFromFulfillment = (fulfillmentId) => {
  const fulfillmentPlanAmountSummary = useGetFulfillmentPlanAmountSummaryFromFulfillment(fulfillmentId);
  const salesOrderAmountSummary = useGetSalesOrderAmountSummaryFromFulfillment(fulfillmentId);
  const isShipmentLabelCreatedFromSalesOrder = !!salesOrderAmountSummary;

  return isShipmentLabelCreatedFromSalesOrder ? fulfillmentPlanAmountSummary : salesOrderAmountSummary;
};
